//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { faArrowRight } from '@fortawesome/pro-regular-svg-icons';
import * as documentsApi from '@motionelements/core/src/api/agreements.js';

export default {
  name: 'TermsOfUse',
  components: {
    PageMeta: () => import('@motionelements/core/src/components/ThePageMeta.vue'),
  },
  data() {
    return {
      faArrowRight,
      document: null,
      isDocumentLoading: false,
    };
  },
  async fetch() {
    return this.getDocumentById();
  },
  mounted() {
    if (!this.document && !this.isDocumentLoading) {
      this.getDocumentById();
    }
  },
  computed: {
    pageTitle() {
      return this.$t('cta.terms_of_service');
    },
    description() {
      if (_.get(this.document, 'body')) {
        const startIndex = this.document.body.indexOf('<p');
        const endIndex = this.document.body.indexOf('</p>', startIndex);
        const paragraphContent = this.document.body.substring(startIndex, endIndex);
        const paragraphContentTrim = paragraphContent
          .replace(/<\/?[^>]+(>|$)/g, '')
          .trim();
        if (paragraphContentTrim.length > 160) {
          return `${paragraphContentTrim.substring(0, 157)}...`;
        }
        return paragraphContentTrim;
      }
      return null;
    },
    updatedAt() {
      return this.document && this.$date(this.document.updatedAt).formatLocalized('PPP');
    },
  },
  methods: {
    async getDocumentById() {
      this.isDocumentLoading = true;
      return documentsApi.getAgreement('studio-ai-terms')
        .then(({ data: { data } }) => {
          if (_.get(data, 'id')) {
            this.document = data;
          } else {
            this.$router.push(this.$link('/legal/license').fullPath());
          }
        })
        .catch(err => {
          console.error(err);
        })
        .finally(() => {
          this.isDocumentLoading = false;
        });
    },
  },
};
